import { render, staticRenderFns } from "./assignedCreativesTable.vue?vue&type=template&id=974f1e5a&scoped=true&lang=pug"
import script from "./assignedCreativesTable.vue?vue&type=script&lang=js"
export * from "./assignedCreativesTable.vue?vue&type=script&lang=js"
import style0 from "./assignedCreativesTable.vue?vue&type=style&index=0&id=974f1e5a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974f1e5a",
  null
  
)

export default component.exports